import _ from 'lodash'
import { API_URL } from '../config'

// 通用模块
export const common = {
  base: API_URL + 'v1/base/list', // 学科列表
  area: API_URL + 'v1/user/area/' // 省市区，顶级pid为0{pid}
}

// 首页
export const index = {
  data: API_URL + 'v1/doc/index-data'
}
// 用户中心
export const user = {
  // userInfo: API_URL + 'v1/user/my-info',
  // getGrade: API_URL + 'v1/user/grade',
  // getSex: API_URL + 'v1/user/sex',
  // searchSchool: API_URL + 'v1/user/school/',
  // updateInfo: API_URL + 'v1/user/update-info',
  // updatePic: API_URL + 'v1/user/user-pic',
  // userAbility: API_URL + 'v1/intelligent/capability-model',
  // // vipInfo: API_URL + 'v1/user/vip-info',
  // getUserInfo: API_URL + 'v1/user/user-info', // 个人信息
  // noticeList: API_URL + 'v1/user/notice-list', // 通知列表
  // clearNotice: API_URL + 'v1/user/clear-notice', // 清空通知列表
  // activityList: API_URL + 'v1/user/activity-list', // 活动列表
  // myExam: API_URL + 'v1/user/my-exam', // 我的考试
  // myReport: API_URL + 'v1/user/my-report', // 我的报告
  // exerciseList: API_URL + 'v1/user/exercise-list/', // 练习记录
  // myCollect: API_URL + 'v1/user/collect/', // 我的收藏
  // myError: API_URL + 'v1/wrong-test/knowledge', // 我的错题
  // uploadList: API_URL + 'v1/wrong-test/pic-list', // 我的错题上传列表
  // uploadTest: API_URL + 'v1/wrong-test/upload-test', // 上传错题
  // deleteError: API_URL + 'v1/wrong-test/pic-delete', // 删除错题
  // vipOrder: API_URL + 'v1/user/vip-order', // 购买记录
  // feedback: API_URL + 'v1/app/feedback', // 建议反馈
  // getVIPInfo: API_URL + 'v1/user/vip-info', // VIP价格列表
  // getPayType: API_URL + 'v1/user/pay-type', // 支付类型列表
  // buyVip: API_URL + 'v1/user/buy-vip', // 购买VIP
  // orderStatus: API_URL + 'v1/user/order-status' // 查询订单状态
}

// 登录
export const login = {
  // login: API_URL + 'v1/user/login', // 登录
  // getCode: API_URL + 'v1/user/sendmsg', // 注册验证码
  // register: API_URL + 'v1/user/register', // 注册
  // editPwd: API_URL + 'v1/user/editpwd', // 修改密码
  // getPwdCode: API_URL + 'v1/user/sendpwdmsg' // 修改密码验证码
}

let modules = {
  common,
  user,
  login
}

let countApi = _.map(_.keys(modules), key => {
  return _.keys(modules[key]).length
})
console.log(countApi.reduce((a, b) => a + b), '接口数量')

export default modules
